// Ball physics constants (event-driven solver, physics/solver.ts). Pure numbers, no imports.
//
// Motion law between events: exponential damping, dv/dt = -DAMPING * v, the same cloth model the game had with Box2D
// (SetLinearDamping(1.5) stepped at 1/60 s: v *= 1 - 1.5/60 per step, so a ball travels 0.65 * v before it stops).
// DAMPING = 1 / 0.65 makes the continuous law travel exactly that far:
//   v(t) = v0 e^(-k t),  x(t) = x0 + v0 (1 - e^(-k t)) / k,  total distance |v0| / k.
// Why this law: every ball shares the same k, so in the "damped clock" s = (1 - e^(-k t)) / k all balls move in
// straight lines at constant velocity. Ball-ball contact is then an exact quadratic in s, ball-cushion and pocket
// entry are linear, and t is recovered exactly with t = -ln(1 - k s) / k. No iterative root finding is needed.
// Stopping distances: 10 / 30 / 60 u/s -> 6.47 / 19.47 / 38.97 units = 0.49 / 1.46 / 2.92 table lengths (as before).
export const DAMPING = 1 / 0.65;          // 1/s
/** A ball whose speed falls to this is stopped (exactly, at the analytic time). Box2D had 0.05 per axis. */
export const STOP_SPEED = 0.05;           // u/s

/** Coefficients of restitution. No velocity threshold: a slow ball bounces in proportion to its speed. */
export const BALL_RESTITUTION = 0.95;
export const CUSHION_RESTITUTION = 0.8;   // cushions, and the pocket jaws (same line and its corner points)

/**
 * Normal approach speeds below this are absorbed (restitution 0) instead of bounced. It is far below anything
 * visible (STOP_SPEED is 500x larger); it only ends the zero-time chains a ball pinned between a ball and a cushion
 * could otherwise produce (each bounce 0.95x the last, forever).
 */
export const MIN_BOUNCE_SPEED = 1e-4;     // u/s
/** Pairs closer than contact are only treated as approaching above this normal speed (numerical noise guard). */
export const APPROACH_EPS = 1e-9;         // u/s

/**
 * At most this many events per shot (the break is a few hundred). Past it the solver stops every ball where it is
 * (positions never overlap, so that is a valid table) and reports it, instead of looping.
 */
export const MAX_EVENTS_PER_SHOT = 20000;

/** Longest real time one rendered frame may advance the simulation (a backgrounded tab resumes, it doesn't jump). */
export const MAX_FRAME_SECONDS = 0.25;
